<!-- ADD-MODAL-STRUCTURE -->
<div class="master-modal renew_modal" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <!-- Modal-Header -->
      <!-- <div class="modal-header">
        <h4 class="modal-title">Add User</h4>       
      </div> -->
      <!-- Modal content-->
      <perfect-scrollbar class="modal-body-scrollbar">
        <div mat-dialog-content>
          <!-- Modal-Body -->
          <div class="modal-body br-8 p-0">
            <div class="modal_close_btn">
              <span (click)="dialogClose()" class="modal-close"><i class="material-icons">close</i></span>
            </div>
            <div class="plan_box_main">
              <div class="plan_head">
                <h4>Premium</h4>
              </div>
              <div class="plan_body">
                <div class="plan_items_listing">
                  <ul>
                    <li><img src="../../../../../assets/images/icons/round_check.svg" alt="">View Catalogues
                    </li>
                    <li><img src="../../../../../assets/images/icons/round_check.svg" alt="">Buy & Sale 2nd hand
                      supplies sae</li>
                    <li><img src="../../../../../assets/images/icons/round_check.svg" alt="">Register for
                      Education</li>
                    <li><img src="../../../../../assets/images/icons/round_check.svg" alt="">Add / Seek Job</li>
                    <li><img src="../../../../../assets/images/icons/round_check.svg" alt="">View Directory (
                      Basic Info )</li>
                    <li><img src="../../../../../assets/images/icons/round_check.svg" alt="">Dental Practice For
                      sale</li>
                    <li><img src="../../../../../assets/images/icons/round_check.svg" alt="">Profile & Personal
                      Details</li>
                  </ul>
                </div>
              </div>
              <div class="plan_footer">
                <div class="price">
                  <h4>$300 <sub>/Month</sub></h4>
                </div>
                <div class="price_btn">
                  <button class="btn btn-sm global-btn" mat-button>Subscribe</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </perfect-scrollbar>
      <!-- Modal-Footer -->
      <!-- <div class="modal-footer">
        <div mat-dialog-actions class="modal_footer">
          <button mat-button (click)="dialogClose()" class="modal-cancel-btn modal-footer-btn">
            <span>Cancel</span>
          </button>
          <button mat-button class="modal-save-btn global-btn modal-footer-btn">
            <span>Save</span>
          </button>
        </div>
      </div> -->
    </div>
  </div>
</div>
